module.exports = __webpack_public_path__ + "img/selected.125aaa87.svg";